// removed by extract-text-webpack-plugin
module.exports = {"form":"bmwW","groupTitle":"_2tpV","footer":"_3Pdy"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/Flow/TrayMenu/TrayMenu.scss
// module id = s740
// module chunks = 0